import { render } from "./ImageSignature.vue?vue&type=template&id=cb60d68e"
import script from "./ImageSignature.vue?vue&type=script&lang=js"
export * from "./ImageSignature.vue?vue&type=script&lang=js"

import "./ImageSignature.vue?vue&type=style&index=0&id=cb60d68e&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__